export const ecommerceTabsArticle = {
  title: 'Ecommerce Hub: Content Tabs',
  slug: 'ecommerce-tabs',
  content: `Ecommerce Hub: Content Tabs

Use the hub tabs to generate product content.

1) Product Descriptions
- Draft product descriptions with AI.

2) Product Titles
- Generate optimized product titles.

3) Category Pages
- Create category landing page copy.

4) Product Reviews
- Draft review summaries and snippets.

Tip
- Tabs are hash-based (#product-descriptions, #product-titles, #category-pages, #product-reviews).
`,
};
